import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTASection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 px-4 bg-brand-red text-center" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-10 font-serif" data-id="element-56">
          ¿Listo para transformar tus clases?
        </h2>
        <CTAButton variant="gold" onClick={scrollToPricing} className="text-lg py-5 px-10 text-brand-text" data-id="element-57">
          QUIERO EL PACK MÚSICA LISTA
        </CTAButton>
      </div>
    </section>;
}